const Roles = [
  {
    path: '/ecommerce/security/roles',
    name: 'roles',
    component: () => import(/* webpackChunkName: "roles" */ '../views/RoleView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Roles',
          path: '/ecommerce/security/roles',
        },
      ],
    },
    children: [],
  },
];

export default Roles;
